/** ----------------------------------------
    Front routes
 ---------------------------------------- */

import authRoutes from '@router/routes/auth';
import quickscanRoutes from '@router/routes/quickscan';
import dashboardRoutes from '@router/routes/dashboard';
import errorsRoutes from '@router/routes/errors';
import applyRoutes from '@router/routes/apply';

const routes = [
    {
        path: '',
        redirect: '/home',
        component: () => import('@view/layout/Master.vue'),
        children: [
            {
                path: '/dev',
                name: 'dev',
                component: () => import('@view/templates/Dev.vue'),
            },
            {
                path: '/',
                name: 'home',
                component: () => import('@view/templates/Home.vue'),
            },
            ...authRoutes,
            ...quickscanRoutes,
            ...applyRoutes,
            ...dashboardRoutes,
            ...errorsRoutes,
        ],
    }
];

/** ----------------------------------------
    Export Modules
 ---------------------------------------- */

export default routes;